// widgets/product-catalog-section/ui/cards/registry.ts
//
// Сопоставление «id шаблона → компонент». Через него каталог и превью в админке
// получают одну и ту же карточку: добавление шестого шаблона — одна строка здесь
// плюс запись в CATALOG_CARD_TEMPLATE_META (shared/config/appearance.ts).

import type { Component } from 'vue';
import ProductCardClassic from './ProductCardClassic.vue';
import ProductCardCompact from './ProductCardCompact.vue';
import ProductCardOverlay from './ProductCardOverlay.vue';
import ProductCardRow from './ProductCardRow.vue';
import ProductCardShowcase from './ProductCardShowcase.vue';
import type { CatalogCardTemplate } from '@shared/config';

export const CATALOG_CARD_COMPONENTS: Record<CatalogCardTemplate, Component> = {
  classic: ProductCardClassic,
  compact: ProductCardCompact,
  overlay: ProductCardOverlay,
  row: ProductCardRow,
  showcase: ProductCardShowcase,
};

/** Компонент шаблона. Неизвестный id (кривой params_json) откатывается на классику. */
export const resolveCatalogCardComponent = (template: CatalogCardTemplate): Component =>
  CATALOG_CARD_COMPONENTS[template] ?? CATALOG_CARD_COMPONENTS.classic;
